import { render, staticRenderFns } from "./InsButton.vue?vue&type=template&id=f71788c8&scoped=true&"
import script from "./InsButton.vue?vue&type=script&lang=ts&"
export * from "./InsButton.vue?vue&type=script&lang=ts&"
import style0 from "./InsButton.vue?vue&type=style&index=0&id=f71788c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71788c8",
  null
  
)

export default component.exports